import { LoadingIcon } from '@/components/icons';
import Icon from '@/components/icons/Icon';
import { IconVariant } from '@/components/icons/types';
import { classnames } from '@/helpers';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type FakeSearchInputProps = {
  valid: boolean;
  content: string | ReactNode;
  icon: IconVariant;
  className?: string;
  size?: 'sm' | 'md';
  isLoading: boolean;
  onClick: () => void;
  onClear: () => void;
};

const FakeSearchInput = ({
  valid,
  content,
  icon,
  className = '',
  size = 'sm',
  isLoading = false,
  onClick,
  onClear,
}: FakeSearchInputProps) => {
  const contentContainerClassNames = classnames(
    'flex-grow cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap',
    valid ? 'text-fg_alwaysDark' : 'text-fg_secondary',
    size === 'sm' ? 'leading-[48px]' : 'leading-[52px]',
  );

  return (
    <div
      className={twMerge(
        classnames(
          'border-border_regular relative flex items-center rounded-full border bg-white',
          size === 'sm' ? 'h-[48px]' : 'h-[52px]',
        ),
        className,
      )}>
      <div className="pl-xs py-xs pr-xs flex h-full items-center justify-center">
        {isLoading && <LoadingIcon className="h-xl w-xl" />}
        {!isLoading && <Icon variant={icon} size="sm" />}
      </div>
      <div className={contentContainerClassNames} onClick={onClick}>
        {content}
      </div>
      {valid && (
        <button
          className="bg-bg_secondary mr-xs flex h-[32px] w-[32px] items-center justify-center rounded-full outline-none"
          onClick={onClear}>
          <Icon variant="close" />
        </button>
      )}
    </div>
  );
};

export default FakeSearchInput;
